import { Box, Typography } from "@mui/material";
import pic from "assets/splashpage/strategy.jpg";
import { AlertContext } from "contexts/Alert";
import { SplashPage } from "contexts/Subscription";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AddOnItemName } from "schemas/dashboard";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import { getSource } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

import SplashPageHome from "../components/Home";

const StrategyPackageSplashPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const source = getSource();
  const { setAlert } = useContext(AlertContext);
  const notQualified = true;
  const { handleCheckout } = useSubscription();

  const checkOutForSplashPage = (plan: Plans) => {
    if (notQualified) {
      setAlert("You have already paid for this item.", "info");
      navigate(`/${routes.home}${location.search}`, { replace: true });
    } else {
      handleCheckout(
        AddOnItemName.strategy_package,
        source || "",
        location.pathname,
        SplashPage.strategy_package,
      );
    }
  };

  return (
    <SplashPageHome
      checkOutForSplashPage={checkOutForSplashPage}
      sidebarPic={pic}
      planDetails={
        <>
          <Typography variant="h2">Bento's 1:1 Strategy Pack</Typography>
          <Typography variant="h6">
            Personalized support + powerful automation.
          </Typography>
          <Typography>
            A plan that combines hands-on support with Bento's AI-powered
            outreach — so you can start landing brand deals faster.
          </Typography>

          <Box sx={{ mt: 6 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>What's included</strong>
            </Typography>
            🟢 <strong>1:1 Onboarding + Strategy Call </strong> Work directly
            with our team to refine your goals and map out a brand deal strategy
            tailored to you. <br />
            🟢 <strong>Custom Pitch Creation (2 Niches) </strong>We'll review
            your outreach, fix what's not working, and craft two high-converting
            pitches.
            <br />
            🟢 <strong>3 Months of Bento's Virtual Assistant </strong>Our AI
            agent will send 300+ targeted pitches every month on your behalf,
            plus smart follow-ups.
            <br />
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>Why It Works</strong>
            </Typography>

            <li>
              Clarity + Strategy: Get personalized advice from real experts.
            </li>
            <li>
              Done-for-you Execution: 900+ pitches send out to you over 3
              months.
            </li>
            <li>Faster Results: Perfect blend of coaching + automation.</li>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>Plan Value</strong>
            </Typography>

            <li>1:1 Onboarding Call - $200</li>
            <li>Custom Pitch Creation (2 niches) - $60</li>
            <li>3 Months of Bento's Virtual Assistant - $195</li>

            <Typography sx={{ mt: 2 }}>
              Total Value:{" "}
              <Box component="span" sx={{ textDecoration: "line-through" }}>
                $455
              </Box>
            </Typography>
          </Box>

          <Typography sx={{ color: "warning.main" }}>
            <em>This program is no longer available</em>
          </Typography>
        </>
      }
      fromRoutes={`${routes.strategyPackage}`}
      plan={AddOnItemName.strategy_package}
      notQualified={notQualified}
    />
  );
};

export default StrategyPackageSplashPage;
